<template>
    <button 
        :disabled="!enabled"
        :type="type" 
        class="
                w-full
                grid
                justify-items-center
                items-center
                font-semibold
                
                border rounded-2xl
                hover:bg-hover
                hover:border-hover
                transition-all
                p-2
                disabled:bg-gray-300 disabled:border-gray-300 disabled:text-gray-500 disabled:pointer-events-none
        "
        :class="
            {
                'border-primary bg-white text-primary' : buttonStyle === 'outline',
                'border-primary bg-primary text-white' : buttonStyle === 'solid'
            }
        "
        >
        <div>
            <slot />
        </div>
    </button>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            default: 'submit',
        },
        buttonStyle: {
            type: String,
            default: 'outline'
        },
        enabled: {
            type: Boolean,
            default: true
        },
    }
}
</script>
